export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7669.2feb10ad.jpg";